import i from "localforage";
function r(o) {
  i.config({
    name: o,
    version: 1,
    storeName: o
  });
}
export {
  r as initLocalforage
};
